import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

PaymentMethod.propTypes = {
  paymentMethod: PropTypes.object,
};

export default function PaymentMethod({ paymentMethod }) {
  const {
    cardType,
    nickname,
    last4,
    expirationMonth,
    expirationYear,
    paymentType,
  } = paymentMethod;

  return (
    <Wrapper>
      {nickname || cardType} •{last4}
      {paymentType === "credit_card" ? (
        <Expires>
          Expires {expirationMonth}/{expirationYear}
        </Expires>
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
`;

const Expires = styled.div`
  font-size: 13px;
  opacity: 0.5;
  margin-left: 10px;
`;
